import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMergedSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMergedSimple"><Path d="M6 2.25C8.07107 2.25 9.75 3.92893 9.75 6C9.75 7.80379 8.47626 9.30921 6.7793 9.66797C7.10174 13.6911 10.3081 16.8968 14.3311 17.2197C14.6901 15.5231 16.1965 14.25 18 14.25C20.0711 14.25 21.75 15.9289 21.75 18C21.75 20.0711 20.0711 21.75 18 21.75C16.1765 21.75 14.6575 20.4484 14.3203 18.7236C11.1295 18.5038 8.36301 16.7504 6.75 14.1934V21.5H5.25V9.6748C3.53834 9.32734 2.25 7.81421 2.25 6C2.25 3.92893 3.92893 2.25 6 2.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMergedSimple;
